<template>
  <main-layout>
    <div>
      <v-row no-gutters align="center" class="content-header">
        <span class="font-weight-bold">Général</span>
        <v-spacer></v-spacer>
      </v-row>
      <div class="page-main-content text-left">
        <div class="text-h6">
          Logo de votre espace Indeego
        </div>
        <n-card class="mt-4">
          <v-row justify="center" align="center" class="ma-4">
            <client-logo large :url="url" />
            <template v-if="newUrl">
              <v-icon class="mx-2">chevron_right</v-icon>
              <client-logo large :url="newUrl" />
            </template>
            <template v-if="isUpdateLogoOpened">
              <input
                @change="setNewLogo"
                type="file"
                ref="newLogoInput"
                id="input-client-logo"
                class="ml-4"
                accept="image/*;capture=camera"
                capture="camera"
              />
              <v-spacer />
              <v-btn
                dark
                color="primary"
                elevation="0"
                :disabled="!newUrl"
                :loading="isUpdatingLogo"
                class="ml-6"
                @click="submit"
              >
                Valider
              </v-btn>
            </template>
            <template v-else>
              <v-spacer />
              <v-btn
                dark
                color="primary"
                elevation="0"
                @click="isUpdateLogoOpened = true"
              >
                Modifier le logo
              </v-btn>
            </template>
          </v-row>
        </n-card>
      </div>
    </div>
  </main-layout>
</template>

<script>
import ClientLogo from '@/components/Settings/Logo.vue';
import MainLayout from '@/views/settings/MainLayout.vue';
import { mapActions, mapState } from 'vuex';

export default {
  data: () => ({
    newClientLogo: null,
    isUpdateLogoOpened: false,
    isUpdatingLogo: false,
    newUrl: null,
  }),

  computed: {
    ...mapState(`model/client`, [
      `company`,
    ]),
    url() {
      return this.company.logoUrl || require(`@/assets/img/client-no-logo.png`); // eslint-disable-line
    },
  },

  methods: {
    ...mapActions(`model/client`, [
      `fetchCompany`,
      `updateLogo`,
    ]),
    ...mapActions(`model/user`, [
      `fetchMe`,
    ]),
    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(
          reader.result.replace(/^[^,]+,/g, ``)
        );
        reader.onerror = error => reject(error);
      });
    },
    setNewLogo(event) {
      [this.newClientLogo] = event.target.files;
      this.newUrl = URL.createObjectURL(this.newClientLogo);
    },
    async submit() {
      if (this.newClientLogo && !this.isUpdatingLogo) {
        this.isUpdatingLogo = true;
        try {
          const fileBase64 = await this.fileToBase64(this.newClientLogo);
          const filename = this.newClientLogo.name;
          const mimeType = this.newClientLogo.type;
          await this.updateLogo({
            clientId: this.company.id,
            logo: {
              mimeType,
              filename,
              content: fileBase64,
            },
          });
        } catch (e) {} // eslint-disable-line
        await Promise.all([
          this.fetchCompany(true),
          this.fetchMe(),
        ]);
        this.newClientLogo = null;
        this.newUrl = null;
        this.isUpdatingLogo = false;
        this.isUpdateLogoOpened = false;
      }
    },
  },

  mounted() {
  },

  watch: {
    isUpdateLogoOpened() {
      if (this.isUpdateLogoOpened) {
        setTimeout(() => {
          this.$refs.newLogoInput.click();
        }, 10);
      }
    },
  },

  components: {
    MainLayout,
    ClientLogo,
  },
};
</script>

<style lang="scss">
</style>
